import {
  GetItemsReportRequest,
  GetItemsReportResponse,
} from '@classpass/protobuf-definitions/lib/web/models/partners/sku_order';
import { useQuery } from '@tanstack/react-query';

import URLS from 'constants/urls';
import { transformKeysToCamelCase } from 'helpers/core';
import { reportError } from 'helpers/error-logging';
import { httpClient } from 'helpers/http';

import { normalizeItemsReport } from './SkuItemReports.normalizers';

export const skuItemReportsKeys = {
  all: ['skuItemReports'],
  items: filter => [...skuItemReportsKeys.all, 'items', filter],
};

async function fetchItemsReport(filter) {
  try {
    const response = await httpClient.post(URLS.reports.skuItems, GetItemsReportRequest.toJSON(filter), {
      ignoreInternalError: true,
    });
    return transformKeysToCamelCase(GetItemsReportResponse.fromJSON(response?.data || {}));
  } catch (error) {
    reportError(error);
    throw error;
  }
}

export function useItemsReportQuery(filter) {
  return useQuery({
    queryKey: skuItemReportsKeys.items(filter),
    queryFn: () => fetchItemsReport(filter),
    enabled: Boolean(filter?.venue_ids?.length),
    select: normalizeItemsReport,
  });
}
